import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const IDCardIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M20.28 18.54H3.72V5.38H20.28V18.54ZM18.52 16.78V7.14H5.48V16.78H18.52ZM9.08 11.52C8.36 11.52 7.78 10.92 7.78 10.2C7.78 9.48 8.36 8.88 9.08 8.88C9.82 8.88 10.4 9.48 10.4 10.2C10.4 10.92 9.82 11.52 9.08 11.52ZM12.52 9.4H16.66V11H12.52V9.4ZM11.22 14.58H6.96C6.96 13.42 7.94 12.46 9.1 12.46C10.26 12.46 11.22 13.42 11.22 14.58ZM12.52 12.98H16.66V14.58H12.52V12.98Z" />
    </SvgIcon>
  );
});
